import {
  norlizeColumns
} from 'utils/handle'
import {
  StatusValidDisplayEnmus
} from 'utils/enmus'


// 需求
const DemandColumnsMaps = new Map()
DemandColumnsMaps.set('genre', '类型')
DemandColumnsMaps.set('type', '类别')
DemandColumnsMaps.set('projectName', '所属项目')
DemandColumnsMaps.set('demandName', '需求')
DemandColumnsMaps.set('costTime', '耗费时间')
DemandColumnsMaps.set('planProgressRate', '计划完成度')
DemandColumnsMaps.set('reachGoalFlag', '计划达标情况')
DemandColumnsMaps.set('overdueInstructions', '逾期情况说明')
// DemandColumnsMaps.set('status', {
//     label: '状态',
//     formatter: row => StatusValidDisplayEnmus.find(v => v.value === row.status).label
// })
class Demand {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'projectName', 'demandName', 'costTime'],
      DemandColumnsMaps
    )
  }
}


// 任务
const TaskColumnsMaps = new Map()
TaskColumnsMaps.set('genre', '类型')
TaskColumnsMaps.set('type', '类别')
TaskColumnsMaps.set('projectName', '所属项目')
TaskColumnsMaps.set('content', {
  label: '任务说明',
  formatter: (v) => {
    return v.replace(/\n/g, '<br/>');
  }
})
TaskColumnsMaps.set('costTime', '耗费时间')
TaskColumnsMaps.set('reachGoalFlag', '计划达标情况')
TaskColumnsMaps.set('overdueInstructions', '逾期情况说明')
// TaskColumnsMaps.set('status', {
//     label: '状态',
//     formatter: row => StatusValidDisplayEnmus.find(v => v.value === row.status).label
// })

// 超出任务
const TaskOVerColumnsMaps = new Map();
TaskOVerColumnsMaps.set('genre', '类型')
TaskOVerColumnsMaps.set('type', '类别')
TaskOVerColumnsMaps.set('projectName', '所属项目')
TaskOVerColumnsMaps.set('demandName', '需求')
TaskOVerColumnsMaps.set('costTime', '耗费时间')
TaskOVerColumnsMaps.set('planProgressRate', '计划完成度')


class Task {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'projectName', 'content', 'costTime'],
      TaskColumnsMaps
    )
  }
}

class TWDemand {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'projectName', 'demandName', 'planProgressRate', 'reachGoalFlag,200', 'overdueInstructions'],
      DemandColumnsMaps
    )
  }
}

class TaskOver {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'projectName', 'demandName', 'planProgressRate'],
      TaskOVerColumnsMaps
    )
  }
}

class TWTask {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'content', 'reachGoalFlag', 'overdueInstructions'],
      TaskColumnsMaps
    )
  }
}

class NWDemand {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'projectName', 'demandName', 'planProgressRate'],
      DemandColumnsMaps
    )
  }
}

class NWTask {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['type', 'content'],
      TaskColumnsMaps
    )
  }
}

// 需求
const MeetingColumnsMaps = new Map()
MeetingColumnsMaps.set('projectName', '加班项目')
MeetingColumnsMaps.set('projectVersionName', '项目版本')
MeetingColumnsMaps.set('overTimeDate', '加班日期')
MeetingColumnsMaps.set('costTime', '加班时长(小时)')
// MeetingColumnsMaps.set('endTime', '耗费时间')
// MeetingColumnsMaps.set('status', {
//     label: '状态',
//     formatter: row => StatusValidDisplayEnmus.find(v => v.value === row.status).label
// })
// MeetingColumnsMaps.set('type', {
//   label: '会议类型',
//   formatter: row => {
//     return row === 1 ? '售前会议' : (row === 2 ? '项目会议' : '暂无信息')
//   }
// })

class Meeting {
  constructor(v) { // 构造函数
    v = v || {}
  }

  static get tableColumns() {
    return norlizeColumns(
      ['projectName', 'projectVersionName', 'overTimeDate', 'costTime'],
      MeetingColumnsMaps
    )
  }
}


export {
  Demand,
  Task,
  TWDemand,
  TWTask,
  NWDemand,
  NWTask,
  Meeting,
  TaskOver
}



// WEBPACK FOOTER //
// ./src/views/report-manage/projectDTO.js